import React from 'react';
import TextForCell from 'components/Dashboard/Influence/tableComponents/TextForCell';
import { useRef } from 'react';
import CrmEmailDummyItem from './CrmEmailDummyItem';
import thousandCommas from 'components/Dashboard/helpers/thousandCommas';
import time from 'utils/time';
import { useNavigate } from 'react-router';

export const generateStateCell = (status, subNav, text) => {
  return (
    <span
      className={`crm-table-item-state ${
        status ? `crm-table-item-${status.toLowerCase()}` : 'crm-table-item-no-status'
      } ${subNav ? `email-state-${status.toLowerCase()}` : ''}`}
    >
      {text ? text : status === 'PartiallySent' ? 'Sending' : status.split(/(?=[A-Z])/).join(' ') || ''}
    </span>
  );
};

const CrmEmailTableItem = ({ item, dummyItem, team }) => {
  const {
    title,
    status,
    senderDisplayName,
    crmEmailId,
    openedRecordCount,
    finishedSendingAt,
    lastUpdated,
    sendRecordCount,
    lastEditedByUserId,
  } = item;

  const navigate = useNavigate();
  const titleCellRef = useRef(null);
  const lastEditCellRef = useRef(null);
  const fromCellRef = useRef(null);
  const toListCellRef = useRef(null);
  const opensCellRef = useRef(null);
  const lastUpdatedCellRef = useRef(null);
  const sentCellRef = useRef(null);

  const renderEmptyCell = () => {
    return <div className='empty-cell' />;
  };
  if (dummyItem) {
    return <CrmEmailDummyItem dummyItem={dummyItem} />;
  }

  const getUserName = (id) => {
    const user = team.allMembers.find((member) => member.id === id);
    if (user) {
      return user.fullName;
    }
  };

  return (
    <tr className='crm-table-item crm-table-item-emails'>
      <td
        ref={titleCellRef}
        onClick={() => {
          if (status === 'Sent' || status === 'PartiallySent') {
            navigate(`/people/email-performance/${crmEmailId}`, {
              state: { prepopulatedActiveTab: 'Email' },
            });
          } else {
            navigate(`/people/emails/${crmEmailId}`);
          }
        }}
      >
        {title ? <TextForCell text={title.trim()} ref={titleCellRef} /> : <div>Untitled</div>}
      </td>
      <td className='text-center'>{generateStateCell(status) || renderEmptyCell()}</td>
      <td ref={lastEditCellRef}>
        <TextForCell text={getUserName(lastEditedByUserId)} ref={lastEditCellRef} />
      </td>
      <td ref={fromCellRef}>
        <TextForCell text={senderDisplayName} ref={fromCellRef} />
      </td>
      <td ref={toListCellRef}>
        {(
          <div
            style={{ pointerEvents: status === 'Sent' ? 'all' : 'none' }}
            onClick={() =>
              navigate(`/people/email-performance/${crmEmailId}`, {
                state: { prepopulatedActiveTab: 'Recipients' },
              })
            }
            className={status === 'Sent' ? 'crm-table-item-title' : ''}
          >
            <TextForCell text={thousandCommas(sendRecordCount)} ref={toListCellRef} />
          </div>
        ) || renderEmptyCell()}
      </td>
      <td
        ref={opensCellRef}
        className={!!openedRecordCount ? 'crm-table-item-title' : ''}
        onClick={() => {
          if (!!openedRecordCount) {
            navigate(`/people/email-performance/${crmEmailId}`, {
              state: {
                prepopulatedActiveTab: 'Recipients',
                reipientsTab: 'Opened',
              },
            });
          }
        }}
      >
        <TextForCell text={thousandCommas(openedRecordCount)} ref={opensCellRef} />
      </td>
      <td ref={lastUpdatedCellRef}>
        <TextForCell
          tooltip={time(lastUpdated).formatShortDateWithTime()}
          text={time(lastUpdated).formatShortDate()}
          ref={lastUpdatedCellRef}
        />
      </td>
      <td ref={sentCellRef}>
        <div
          data-tooltip-content={
            status === 'Sent' ? time(finishedSendingAt ?? lastUpdated).formatShortDateWithTime() : ''
          }
          data-tooltip-id='general-tooltip'
        >
          {status === 'Sent' ? time(finishedSendingAt ?? lastUpdated).formatShortDate() : renderEmptyCell()}
        </div>
      </td>
    </tr>
  );
};

export default CrmEmailTableItem;
